module.exports = __webpack_public_path__ + "img/android-home-03.88054832.jpg";